import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Disabler, Spinner, Form } from 'lib/ui'
import { useCheckout, usePaymentMethod } from 'lib/modules/checkout'
import { Failure } from 'lib/ui/components/Toast/components/Failure'
import { usePayeezy, usePayeezyTokens, PayeezyTokens, PayeezyCreditCardForm } from 'lib/modules/payeezy'
import { Container } from './styled'

export const Payeezy = () => {
  const { lockCheckout, unlockCheckout } = useCheckout()
  const { payeezyTokens, tokensLoading } = usePayeezyTokens()
  const tokenOptions = getTokenOptions(payeezyTokens)
  const [token, setToken] = useState('')

  const {
    clientToken,
    publicKeyBase64,
    paymentForm,
    loading,
    setPaymentForm,
    clientIsLoading,
    submitForm,
    placeVaultOrder
  } = usePayeezy()

  usePaymentMethod(({ placeOrder }) => {
    if (token) {
      placeVaultOrder({
        publicHash: token,
        onError: () => {
          toast(() => (
            <Failure
              messageId='app.whoops'
            />
          ), {
            autoClose: 15000
          })
        }
      })
      return
    }

    lockCheckout()
    submitForm?.({
      onSuccess: clientToken => {
        /*
          Issue [HDSG-384]: Payeezy is stacking this callbacks each time we run the submitForm.

          Workaround: get to payeezy without anything in memory, that means, get to the
          checkout using window.location.href instead of location.push (react-router-dom)
         */
        unlockCheckout()
        placeOrder({
          additionalData: { clientToken }
        })
      },
      onError: () => unlockCheckout()
    })
  })

  useEffect(() => {
    const defaultToken = payeezyTokens?.find(el => el.payeezy.is_default)?.vault.publicHash
    if (defaultToken) {
      setToken(defaultToken)
    }
  }, [payeezyTokens, setToken])

  if (tokensLoading) {
    return (
      <Container>
        <Spinner />
      </Container>
    )
  }

  return (
    <Container>
      {Boolean(payeezyTokens?.length) && (
        <Form.Select
          label='Card'
          options={tokenOptions}
          form={{}}
          field={{
            name: 'payeezyCcToken',
            value: token,
            onChange: (e) => {
              setToken(e.target.value)
            }
          }}
        />
      )}

      {!token && (
        <Disabler disabled={loading || !paymentForm}>
          {clientIsLoading && (
            <Spinner />
          )}

          {clientToken && publicKeyBase64 && (
            <PayeezyCreditCardForm
              key={`${clientToken}-${publicKeyBase64}`}
              clientToken={clientToken}
              publicKeyBase64={publicKeyBase64}
              onLoad={setPaymentForm}
            />
          )}
        </Disabler>
      )}
    </Container>
  )
}

const getTokenOptions = (payeezyTokens: PayeezyTokens[] = []) => {
  const tokenOptions = payeezyTokens.map(paymentMethod => {
    const { creditCardInfo, expiration, holderName, last4 } = paymentMethod.meta
    return {
      value: paymentMethod.vault.publicHash,
      label: `${creditCardInfo.niceType} - ${last4} (${expiration}) - ${holderName}`
    }
  })

  tokenOptions.unshift({
    value: '',
    label: 'New Card'
  })

  return tokenOptions
}
